import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, Navigate } from "react-router-dom";
import { setLogout, selectUserData } from "features/user/userSlice";

import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(localizedFormat);

let AuthContext = React.createContext(null);

function AuthProvider(props) {
  let user = useSelector(selectUserData);
  let value = { user };
  return (
    <AuthContext.Provider value={value}>{props.children}</AuthContext.Provider>
  );
}

function useAuth() {
  return React.useContext(AuthContext);
}

function isStaticFiles(location) {
  const path = location.pathname;
  //console.log("path", path);
  return path && path.startsWith("/static");
}

function RequireAuth({ children }) {
  let auth = useAuth();
  let location = useLocation();
  const dispatch = useDispatch();

  let isExpiry = false;
  if (auth.user) {
    let now = dayjs.utc();
    let expiryTime = dayjs.utc(auth.user.expiry);
    isExpiry = expiryTime < now;
    console.log("isExpiry", isExpiry);
    console.log("now", now.format());
    console.log("expiryTime", expiryTime.format()); 
  }

  if ((!auth.user || isExpiry) && !isStaticFiles(location)) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    if (isExpiry) {
      dispatch(setLogout(null));
      console.log("Auth token expires!");
    }
    return <Navigate to="/login/" state={{ from: location }} replace />;
  }

  return children;
}

export { AuthProvider, useAuth, RequireAuth };
